export {
    addFocus,
    syntheticFocus,
    applyBlur,
    blurs,
    applyDisabled,
    applyEllipsis,
    applyHyphens,
    applyMaxLines,
    applyNoSelect,
    applyRoundness,
    radiuses,
    applySkeletonGradient,
    applyView,
    views,
    applyScrollSnap,
    shadows,
    applySpacing,
} from '@sberdevices/plasma-core';

export type {
    FocusProps,
    OutlinedProps,
    BlurProps,
    DisabledProps,
    MaxLinesProps,
    RoundnessProps,
    Roundness,
    SkeletonGradientProps,
    ViewProps,
    View,
    ScrollSnapProps,
    SpacingProps,
} from '@sberdevices/plasma-core';
